import { SideBarContext, SideBarContextType } from "@cdv/jazz-ui";
import { Box, CssBaseline } from "@mui/material";
import { ReactElement, useContext, useEffect } from "react";
import { Outlet } from "react-router";
import BottomNavigation from "./BottomNavigation";
import { useSync } from "./Sync";

export default function Layout(): ReactElement {
  const { isTemporary, isNarrow } = useContext<SideBarContextType>(SideBarContext);
  const sync = useSync();

  useEffect(() => {
    const id = setInterval(() => {
      sync();
    }, 6000);

    return () => clearInterval(id);
  }, [sync]);

  return (
    <Box sx={{ display: "flex", background: "#EEF6F8", minHeight: "100vh" }}>
      <CssBaseline />
      <Outlet />
      <BottomNavigation />
    </Box>
  );
}
